import { SearchState } from "react-instantsearch-core";

export interface AppliedFilters {
  refinementList: SearchState["refinementList"];
  toggle: SearchState["toggle"];
  counter: number;
}

export const extractAppliedFilters = (
  searchState: SearchState
): AppliedFilters => {
  const filteredSearchState = {
    refinementList: {},
    toggle: {},
    counter: 0
  };
  const refinementList = searchState?.refinementList || {};
  const toggle = searchState?.toggle || {};
  let appliedFilterCounter = 0;

  const filteredRefinementList = Object.keys(refinementList).reduce<
    NonNullable<AppliedFilters["refinementList"]>
  >((obj, key) => {
    const value = refinementList[key];
    if (value.length > 0) {
      obj[key] = value;
      appliedFilterCounter += value.length;
    }
    return obj;
  }, {});
  if (filteredRefinementList && Object.keys(filteredRefinementList).length > 0)
    filteredSearchState.refinementList = filteredRefinementList;

  const filteredToggle = Object.keys(toggle).reduce(
    (obj: { [key: string]: boolean }, key) => {
      const value = toggle[key];
      if (value != false) {
        obj[key] = value;
        appliedFilterCounter += 1;
      }
      return obj;
    },
    {}
  );
  if (Object.keys(filteredToggle).length)
    filteredSearchState.toggle = filteredToggle;

  filteredSearchState.counter = appliedFilterCounter;
  return filteredSearchState;
};
